var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001246",
    d: "M6 0c.552 0 1 .448 1 1v2c0 .552-.448 1-1 1h-.456c.059.281.172.48.334.61-.012-.01-.005-.013.017-.011l.835.119c.547.085.904.184 1.171.377.291.21.47.518.55.905H9c.552 0 1 .448 1 1v2c0 .552-.448 1-1 1H7c-.552 0-1-.448-1-1V7c0-.552.448-1 1-1h.4c-.024-.04-.053-.072-.085-.095-.082-.06-.286-.12-.598-.176l-.657-.096c-.462-.064-.635-.103-.809-.243-.093-.075-.177-.158-.252-.248-.074.09-.159.173-.252.248-.174.14-.347.179-.808.243l-.657.096c-.312.055-.516.116-.599.176-.032.023-.06.055-.085.095H3c.552 0 1 .448 1 1v2c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1V7c0-.552.448-1 1-1h.548c.079-.387.259-.695.55-.905.267-.193.624-.292 1.17-.377l.836-.12c.022 0 .03.003.017.012.162-.13.275-.329.333-.61H4c-.552 0-1-.448-1-1V1c0-.552.448-1 1-1h2zm3 7H7.833l-.333.001V7H7v2h2V7zM2.165 7H1v2h2V7h-.502v.001L2.166 7zM5.5 3H6V1H4v2h1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.38f68d1c804f15dcbbae8ec5293f23ff.svg";
export { ForwardRef as ReactComponent };